/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'triider-components';
import moment from 'moment';

import tag from 'assets/img/icons/tag.svg';
import notificationIconGrey from 'assets/img/icons/clockNotifGrey.svg';
import userMenu from 'assets/img/icons/userMenu.svg';
import pencilMenu from 'assets/img/icons/pencilMenu.svg';
import closeIcon from 'assets/img/icons/close.svg';
import calendarTicket from 'assets/img/icons/calendar-ticket.svg';
import Colapse from 'components/Colapse';
import { Creators as TaskCreators } from 'store/ducks/task';
import Responsibility from './Responsibility';
import TagsInput from './TagInput';
import SEGMENTS from '../../../helpers/segment';

import {
  Container,
  Toggle,
  IconOpt,
  VerticalLine,
  Menu,
  Title,
  Date,
  ManageTask,
  ManageAdmin,
} from './styles';

function SideMenu({
  _includeTaskLabel,
  _deleteTaskLabel,
  _setTaskOperator,
  task,
  task_id,
  options,
  labels,
  roles,
  loadingSetOperator,
  operator_id,
  userId,
  company,
}) {
  moment.locale('pt-br');
  const [isOpen, setIsOpen] = useState(false);
  const IMOB_SEGMENT = company.segment_id === null || SEGMENTS.IMOBILIARIA === company.segment_id;

  const handleDelete = (label) => {
    _deleteTaskLabel({ ...label, label_id: label.id, task_id });
  };

  const handleAddition = (label) => {
    _includeTaskLabel({ ...label, label_id: label.id, task_id });
  };

  const getStatus = () => {
    switch (task.status) {
      case 'hired':
        return 'Pedido contratado';
      case 'charged':
        return 'Pedido realizado';
      case 'canceled':
        return 'Pedido cancelado';
      case 'paid':
        return 'Pedido pago';
      case 'open':
        return 'Pedido aberto';
      default:
        return '';
    }
  };

  const getContentOperatorTask = () => {
    if (loadingSetOperator) {
      return <Spinner size="small" />;
    }

    if (!operator_id) {
      return (
        <div style={{
          display: 'flex',
          flex: 1,
          padding: '10px',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid #cbcbcb',
          borderRadius: '5px',
        }}
        >
          <ManageTask
            hover
            pointer
            adminTask
            onClick={
              () => _setTaskOperator({ task_id: task.id, operator_id: userId, ofList: false })
            }
          >
            Administrar este pedido
          </ManageTask>
        </div>
      );
    }

    if (operator_id === userId) {
      return (
        <div style={{
          display: 'flex',
          flex: 1,
          padding: '10px',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid #cbcbcb',
          borderRadius: '5px',
        }}
        >
          <ManageTask isManaging iAmManaging> Administrado por você </ManageTask>
          <img
            style={{
              marginLeft: '10px',
              cursor: 'pointer',
            }}
            onClick={() => _setTaskOperator({ task_id: task.id, ofList: false })}
            src={closeIcon}
            width="10px"
            height="10px"
            alt="Desvincular usuário ao pedido"
          />
        </div>
      );
    }

    return (
      <div style={{
        display: 'flex',
        padding: '10px',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #cbcbcb',
        borderRadius: '5px',
      }}
      >
        <ManageAdmin>Administrado por:</ManageAdmin>
        <ManageTask isManaging>
          {task.operator_name}
        </ManageTask>
      </div>
    );
  };

  return (
    <Container
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      isOpen={isOpen}
    >
      {isOpen && (
        <Menu>
          <Title>{getStatus()}</Title>
          <Date>
            {moment(task.created).format('LL')}
          </Date>
          <Colapse icon={pencilMenu} title="Atribuição">
            {getContentOperatorTask()}
          </Colapse>
          {IMOB_SEGMENT
          && (
          <Colapse icon={userMenu} title="Responsável">
            <Responsibility
              roles={roles}
              task={task}
            />
          </Colapse>
          )
          }
          <Colapse icon={tag} title="Tags">
            <TagsInput
              handleAddition={handleAddition}
              handleDelete={handleDelete}
              options={options}
              labels={labels}
            />
          </Colapse>
        </Menu>
      )}
      {isOpen && (
        <VerticalLine />
      )}
      <Menu fixed>
        <Toggle isOpen={isOpen} type="button" />
        <IconOpt icon={pencilMenu} />
        {IMOB_SEGMENT
          && (
          <IconOpt icon={userMenu} />
          )}
        <IconOpt icon={tag} />
        <IconOpt icon={notificationIconGrey} />
        {IMOB_SEGMENT && (
          <IconOpt icon={calendarTicket} />
        )}
      </Menu>

    </Container>
  );
}

const mapStateToProps = state => ({
  task: state.task.taskDetail,
  task_id: state.task.taskDetail.id,
  labels: state.task.taskDetail.labels,
  operator_name: state.task.taskDetail.operator_name,
  operator_id: state.task.taskDetail.operator_id,
  roles: state.companyResponsibility.roles,
  userId: state.auth.triiderUser.user.id,
  company: state.auth.triiderUser.company,
  loadingSetOperator: state.ui.loaders.includes('SET_OPERATOR_TASK'),
  loadingTaskIsNeedVisit: state.ui.loaders.includes('SET_TASK_VISITED_IS_NEED_VISIT'),
  loadingTaskVisit: state.ui.loaders.includes('SET_TASK_VISIT'),
});

const mapDispatchToProps = {
  _includeTaskLabel: TaskCreators.includeLabelsTaskRequest,
  _deleteTaskLabel: TaskCreators.removeLabelsTaskRequest,
  _setTaskOperator: TaskCreators.setTaskOperatorRequest,
  _setTaskVisited: TaskCreators.setTaskIsNeededVisitRequest,
  _editTaskVisit: TaskCreators.editTaskVisitRequest,
};


export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);
